import { BUTTON_SIZES, Button, SecondaryButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';

const MODAL_TEST_TAG = 'confirm-update-display-priority-modal';

type Props = { onConfirm: () => void; onDiscard: () => void; onClose: () => void };

export const ConfirmUpdateDisplayPriorityModal = ({ onConfirm, onDiscard, onClose }: Props) => {
  const handleDiscard = () => {
    onClose();
    onDiscard();
  };

  const handleConfirm = () => {
    onClose();
    onConfirm();
  };

  return (
    <Modal
      data-test={MODAL_TEST_TAG}
      id={MODAL_TEST_TAG}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
      isModalOpen
      withPortal
    >
      <ModalHeader>Unsaved changes</ModalHeader>
      <ModalBody>Display priority has been edited. Do you want to save your changes?</ModalBody>
      <ModalFooter onClose={onClose}>
        <SecondaryButton
          size={BUTTON_SIZES.LARGE}
          data-test={`${MODAL_TEST_TAG}-discard-button`}
          onClick={handleDiscard}
        >
          Discard changes
        </SecondaryButton>
        <Button
          size={BUTTON_SIZES.LARGE}
          data-test={`${MODAL_TEST_TAG}-confirm-button`}
          onClick={handleConfirm}
        >
          Save changes
        </Button>
      </ModalFooter>
    </Modal>
  );
};
